import { Link } from "react-router-dom";
import { CONTACT, PROGRAMS, BRAND } from "../data/content";
import { Linkedin, Instagram, ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="ground-ink text-[color:var(--paper)]">
      <div className="wrap py-24 md:py-32">
        {/* Massive display wordmark */}
        <div className="border-b-[1.5px] border-[color:var(--paper)] pb-16 md:pb-24">
          <p className="stamp on-ink" style={{ color: "var(--paper)" }}>Sign off</p>
          <div className="mt-6 flex flex-wrap items-baseline gap-x-8 gap-y-2">
            <span
              className="font-hook-black text-[color:var(--paper)] relative inline-block"
              style={{ fontSize: "clamp(72px, 15vw, 232px)", lineHeight: 0.85, letterSpacing: "-0.03em" }}
            >
              art<span style={{ position: "relative" }}>i<span aria-hidden="true" style={{ position: "absolute", top: "-0.4em", left: "50%", transform: "translateX(-50%)", width: "0.18em", height: "0.18em", borderRadius: 999, background: "#F9D70A" }} /></span>culex
            </span>
            <span className="italic font-aside text-[color:var(--pink)]" style={{ fontSize: "clamp(22px, 3vw, 42px)" }}>
              Your new age cap-dev partner.
            </span>
          </div>
          <p className="mt-8 font-aside text-[color:rgba(239,231,214,0.7)] max-w-[560px]" style={{ fontSize: 22, lineHeight: 1.4 }}>
            Communication <span className="claim">·</span> Leadership <span className="claim">·</span> AI readiness <span className="claim">·</span> Workflow automation.
          </p>
          <p className="stamp mt-6" style={{ color: "rgba(239,231,214,0.6)", fontSize: 11 }}>
            Founder, Articulex · hello@articulex.com
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mt-16">
          <div className="col-span-2 md:col-span-1">
            <p className="stamp on-ink" style={{ color: "var(--paper)" }}>Studio</p>
            <ul className="mt-6 space-y-3 text-[15px]" style={{ color: "rgba(239,231,214,0.75)" }}>
              <li>{CONTACT.city}</li>
              <li>
                <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="hover:text-[color:var(--paper)]">
                  {CONTACT.email}
                </a>
              </li>
              <li>
                <a href={`tel:+91${CONTACT.phone}`} data-testid="footer-phone" className="hover:text-[color:var(--paper)]">
                  +91 {CONTACT.phone}
                </a>
              </li>
            </ul>
            <div className="flex items-center gap-4 mt-6">
              <a
                href={CONTACT.linkedin}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-linkedin"
                className="text-[color:rgba(239,231,214,0.5)] hover:text-[color:var(--pink)]"
                aria-label="LinkedIn"
              >
                <Linkedin size={18} />
              </a>
              <a
                href={`https://instagram.com/${CONTACT.instagram.replace("@", "")}`}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-instagram"
                className="text-[color:rgba(239,231,214,0.5)] hover:text-[color:var(--pink)]"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
            </div>
          </div>

          <div>
            <p className="stamp on-ink" style={{ color: "var(--paper)" }}>Programs</p>
            <ul className="mt-6 space-y-3">
              {PROGRAMS.map((p) => (
                <li key={p.slug}>
                  <Link
                    to={`/programs/${p.slug}`}
                    data-testid={`footer-program-${p.slug}`}
                    className="text-[14px] text-[color:rgba(239,231,214,0.7)] hover:text-[color:var(--paper)] inline-flex items-center gap-2"
                  >
                    {p.title} <ArrowUpRight size={12} />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="stamp on-ink" style={{ color: "var(--paper)" }}>Studio</p>
            <ul className="mt-6 space-y-3">
              {[
                { to: "/about", label: "About" },
                { to: "/how-we-design", label: "Method" },
                { to: "/who-we-work-with", label: "Rooms" },
                { to: "/insights", label: "Field Notes" },
                { to: "/contact", label: "Contact" }
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.to.replace(/\//g, "")}`}
                    className="text-[14px] text-[color:rgba(239,231,214,0.7)] hover:text-[color:var(--paper)] inline-flex items-center gap-2"
                  >
                    {l.label} <ArrowUpRight size={12} />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="stamp on-ink" style={{ color: "var(--paper)" }}>Elsewhere</p>
            <ul className="mt-6 space-y-3 text-[14px] text-[color:rgba(239,231,214,0.7)]">
              <li>
                <a href={CONTACT.linkedin} target="_blank" rel="noreferrer" className="hover:text-[color:var(--paper)]">LinkedIn</a>
              </li>
              <li>
                <a href={`https://instagram.com/${CONTACT.instagram.replace("@","")}`} target="_blank" rel="noreferrer" className="hover:text-[color:var(--paper)]">Instagram</a>
              </li>
              <li>{CONTACT.domain}</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-[color:rgba(239,231,214,0.2)]">
        <div className="wrap flex flex-col md:flex-row md:items-center md:justify-between gap-2 py-6">
          <p className="stamp" style={{ color: "rgba(239,231,214,0.5)", fontSize: 10 }}>
            © 2025 Articulex · All rights reserved
          </p>
          <p className="stamp" style={{ color: "rgba(239,231,214,0.5)", fontSize: 10 }}>
            Privacy · Terms · Colophon
          </p>
        </div>
      </div>
    </footer>
  );
}
